// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1799":"a747f485","4035":"c7cde834","6172":"5837e0b0","6294":"79b8dcb3","7849":"769093ae"}[chunkId] + ".chunk.css";
};